import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const facebook = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 448 1000",
    fill: "currentColor",
    width: size || '1em',
    height: size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M414 499H288v490H100V499H11V326h89V214c0-80 35-205 189-205l139 1v168H328c-17 0-40 9-40 47v101h143l-17 173z"
  }));
};
facebook.displayName = 'facebook';
export default facebook;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=facebook.js.map